import { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux"
import debounce from 'lodash.debounce';
import { Button, CloseButton, Input, InputGroup, InputLeftElement, InputRightElement, useDisclosure } from "@chakra-ui/react";
import InputField from "components/fields/InputField";
import Modal from "components/modal/Modal";
import { FaEdit, FaPencilAlt, FaPlusCircle, FaTrashAlt } from "react-icons/fa";
import TooltipComponent from "components/tooltip";
import { FiSearch } from "react-icons/fi";
import ButtonPrimary from "components/button/ButtonPrimary";
import { IoAddCircle, IoClose } from "react-icons/io5";
import { SET_TO_DEFAULT_RESPONSE, create, update, del, getByPageProd } from "./../../../store/features/slices/productoSlice";
import { getAlmacenes } from "./../../../store/features/slices/almacenSlice";
import { get as getMedidas } from "./../../../store/features/slices/medidaSlice";
import { get as getCategorias } from "./../../../store/features/slices/categorySlice";
import { get as getMarcas } from "./../../../store/features/slices/marcaSlice";
import { message as alerta } from "utils/Funciones";
import { uriSerialized } from "utils/uriSerialized";
import { alertaConfirmar } from "utils/Funciones";
import SwitchToggle from "components/fields/SwitchToggle";
import AutoComplete from "components/autocomplete/AutoComplete";
import ImagenPreview from "components/imagenpreview/ImagenPreview";
import ImagenPreviewEdit from "components/imagenpreview/ImagenPreviewEdit";
import TextField from "components/fields/TextField";
import moment from 'moment';
import 'moment/locale/es';
import TablePagination from "./table/TablePagination";

const Productos = () => {
    const dispatch = useDispatch();
    const { userToken, user } = useSelector((state) => state.userReducer);
    const {
        dataByPageProd: dataByPage,
        totalPageProd: totalPage,
        totalRowProd: totalRow,
        totalProd: total,
        responseSuccessCreate,
        isLoading,
        isSuccess,
        isError,
        message,
        responseSuccessGet,
        responseSuccessDelete,
        responseSuccessUpdate
    } = useSelector((state) => state.productoReducer);

    const { data: almacenes } = useSelector((state) => state.almacenReducer);

    const { data: categorias } = useSelector((state) => state.categoryReducer);

    const { data: marcas } = useSelector((state) => state.marcaReducer);

    const { data: medidas } = useSelector((state) => state.medidaReducer);

    const registrar = useDisclosure()
    const editar = useDisclosure()
    const [searchTerm, setSearchTerm] = useState('');
    const [state, setState] = useState({
        name: '',
        tipo: 'producto',
        detalles: '',
        categoria: '',
        marca: '',
        almacen: '',
        medida: '',
        codigointerno: '',
        stock: 0,
        precioventa: 0,
        preciocompra: 0,
        preciomayor: 0,
        preciodistrubuidor: 0,
        currentimagen: '',
        imagen: '',
        last_update: '',
        disabled: false
    })

    const setDefaultState = () => {
        setState({
            ...state,
            name: '',
            tipo: 'producto',
            detalles: '',
            categoria: '',
            marca: '',
            almacen: '',
            medida: '',
            codigointerno: '',
            stock: 0,
            precioventa: 0,
            preciocompra: 0,
            preciomayor: 0,
            preciodistrubuidor: 0,
            currentimagen: '',
            imagen: '',
            last_update: '',
            disabled: false
        })

        setPreview({ ...preview, imagen: '' })
    }

    const [preview, setPreview] = useState({
        imagen: '',
    })

    const [previewEdit, setPreviewEdit] = useState({
        imagen: '',
    })

    const imageHandle = e => {
        if (e.target.files.length !== 0) {
            setState({ ...state, [e.target.name]: e.target.files[0] });
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreview({ ...preview, [e.target.name]: reader.result })
            }
            reader.readAsDataURL(e.target.files[0]);
        }
    }

    const imageHandleEdit = e => {
        if (e.target.files.length !== 0) {
            setStateEdit({ ...stateEdit, [e.target.name]: e.target.files[0] });
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreviewEdit({ ...previewEdit, [e.target.name]: reader.result })
            }
            reader.readAsDataURL(e.target.files[0]);
        }
    }

    const [stateEdit, setStateEdit] = useState({
        _id: '',
        name: '',
        tipo: 'producto',
        detalles: '',
        categoria: '',
        marca: '',
        almacen: '',
        medida: '',
        codigointerno: '',
        stock: 0,
        precioventa: 0,
        preciocompra: 0,
        preciomayor: 0,
        preciodistrubuidor: 0,
        currentimagen: '',
        imagen: '',
        last_update: '',
        disabled: false
    })

    const columnsDataColumns = useMemo(
        () => [
            {
                Header: "Imagen",
                accessor: "imagen",
                type: 'String'
            }, {
                Header: "Nombre",
                accessor: "name",
                type: 'String'
            }, {
                Header: "Marca",
                accessor: "marca",
                type: 'String'
            }, {
                Header: "Almacen",
                accessor: "almacen",
                type: 'String'
            }, {
                Header: "Cod. interno",
                accessor: "codigointerno",
                type: 'String'
            }, {
                Header: "Stock",
                accessor: "stock",
                type: 'Number'
            }, {
                Header: "P. compra",
                accessor: "preciocompra",
                type: 'Number'
            }, {
                Header: "P. venta",
                accessor: "precioventa",
                type: 'Number'
            }, {
                Header: "Estado",
                accessor: "disabled",
                type: 'Boolean'
            }, {
                Header: "F. registro",
                accessor: "created_at",
                type: 'Date'
            },
            {
                Header: "Opciones",
                accessor: "opciones",
                type: 'opciones',
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div className="flex gap-5">
                        <TooltipComponent
                            trigger={<Button onClick={() => handleEdit(row.original)} colorScheme={'yellow'} className="rounded-xl bg-yellow-500 !px-1 !py-1 text-base font-medium text-white transition duration-200 hover:bg-yellow-600 active:bg-yellow-700 dark:bg-yellow-400 dark:text-white dark:hover:bg-yellow-300 dark:active:bg-yellow-200">
                                <FaPencilAlt className="w-4 h-4 text-white" />
                            </Button>}
                            content={
                                <p className="dark:text-white">
                                    editar
                                </p>
                            }
                        />
                        <TooltipComponent
                            trigger={<Button onClick={() => handleDelete(row.original)} colorScheme={'red'} className="rounded-xl bg-red-500 !px-1 !py-1 text-base font-medium text-white transition duration-200 hover:bg-red-600 active:bg-red-700 dark:bg-red-400 dark:text-white dark:hover:bg-red-300 dark:active:bg-red-200">
                                <FaTrashAlt className="w-4 h-4 text-white" />
                            </Button>}
                            content={
                                <p className="dark:text-white">
                                    eliminar
                                </p>
                            }
                        />
                    </div>
                )
            },
        ],
        []
    );

    function handleEdit(row) {
        setStateEdit({
            ...stateEdit,
            _id: row._id,
            name: row.name,
            tipo: row.tipo,
            detalles: row.detalles,
            categoria: row.categoria._id,
            marca: row.marca._id,
            almacen: row.almacen._id,
            medida: row.medida._id,
            codigointerno: row.codigointerno,
            stock: row.stock,
            precioventa: row.precioventa,
            preciocompra: row.preciocompra,
            preciomayor: row.preciomayor,
            preciodistrubuidor: row.preciodistrubuidor,
            currentimagen: row.imagen,
            last_update: row.last_update,
            disabled: row.disabled
        })
        editar.onOpen()
    }

    function handleDelete(row) {
        alertaConfirmar('Eliminar Producto', `Estas seguro que quieres eliminar el producto <b>${row.name}</b>? recuerda que se eliminarán todos los datos relacionados a este.`, 'question', async (res_alert) => {
            if (res_alert === true) {
                await dispatch(del({ _id: row._id, token: userToken }));
            }
        })
    }

    const handleInputs = e => {
        setState({ ...state, [e.target.name]: e.target.value })
    }

    const handleEditInputs = e => {
        setStateEdit({ ...stateEdit, [e.target.name]: e.target.value })
    }

    const onSubmitRegistrar = async e => {
        e.preventDefault();
        if (state.name.trim().length > 0) {
            const formData = new FormData();
            state.userId = userToken && user?.id
            formData.append('data', JSON.stringify(state));
            formData.append('imagen', state.imagen)
            await dispatch(create({ formData: formData, token: userToken }));

        } else {
            alerta('Nombre y abreviatura son requeridos', 'error', 4)
        }
    }

    const onSubmitEditar = async e => {
        e.preventDefault();
        if (stateEdit.name.trim().length > 0) {
            const formData = new FormData();
            formData.append('data', JSON.stringify(stateEdit));
            formData.append('imagen', stateEdit.imagen)
            await dispatch(update({ formData: formData, token: userToken }));

        } else {
            alerta('Nombre y abreviatura son requeridos', 'error', 4)
        }
    }

    useEffect(() => {
        if (responseSuccessCreate) {
            alerta(responseSuccessCreate.message, 'success', 5)
            setDefaultState()
            registrar.onClose()
        }
        dispatch(SET_TO_DEFAULT_RESPONSE())
    }, [responseSuccessCreate])

    useEffect(() => {
        if (responseSuccessDelete) {
            alerta(responseSuccessDelete.message, 'success', 5)
        }
        dispatch(SET_TO_DEFAULT_RESPONSE())
    }, [responseSuccessDelete])

    useEffect(() => {
        if (responseSuccessGet) {
            var str = 'PROD_'
            var _total = (Number(total) + 1)
            if (_total > 0 && _total < 10) {
                str += '000' + _total
            } else if (_total >= 10 && _total < 99) {
                str += '00' + _total
            } else if (_total >= 100 && _total < 999) {
                str += '0' + _total
            } else if (_total >= 1000 && _total < 9999) {
                str += _total
            } else {
                str += _total
            }
            setState({ ...state, codigointerno: str })
        }
        dispatch(SET_TO_DEFAULT_RESPONSE())
    }, [responseSuccessGet])

    useEffect(() => {
        if (responseSuccessUpdate) {
            alerta(responseSuccessUpdate.message, 'success', 5)
            setState({ ...state, name: "", direccion: "" })
            editar.onClose()
        }
        dispatch(SET_TO_DEFAULT_RESPONSE())
    }, [responseSuccessUpdate])

    const fetchData = useCallback(
        (pageSize, pageIndex, search, order) => {
            const queryOptions = {
                page: pageIndex,
                limit: pageSize,
                search: search,
                order: order
            }
            const query = queryOptions ? "?" + uriSerialized(queryOptions) : ""
            dispatch(getByPageProd({ query: query, token: userToken }))
        },
        [responseSuccessDelete, responseSuccessCreate]
    )

    const onChangeSearchTerm = e => {
        setSearchTerm(e.target.value);
    };

    const onChangeSearchTermClear = e => {
        setSearchTerm("");
        document.getElementById("search").value = "";
    };

    const debounceSearchTerm = useMemo(() => debounce(onChangeSearchTerm, 700), []);

    useEffect(() => {
        dispatch(getAlmacenes(userToken));
        dispatch(getMedidas(userToken));
        dispatch(getCategorias(userToken));
        dispatch(getMarcas(userToken));
    }, [dispatch])


    return (
        <div className="mt-4 md:mt-0">
            <div className="sticky z-30 w-full top-44 md:top-28 flex items-center justify-end bg-white dark:!bg-navy-800 p-2 rounded-xl shadow-xl shadow-gray-200 dark:shadow-none">
                <div className="relative flex h-[61px] w-[calc(100%-55px)] flex-grow items-center gap-2 rounded-full bg-white px-0 py-2 dark:!bg-navy-800">
                    <InputGroup className="!w-full md:!w-[300px]">
                        <InputLeftElement pointerEvents="none" className="!mt-1 !ml-1">
                            <FiSearch size={24} className="text-navy-500 dark:text-navy-300" />
                        </InputLeftElement>
                        <Input size='lg' autoFocus id="search" onChange={debounceSearchTerm} type="text" placeholder={`Buscar ${totalRow} productos...`} className="flex w-full items-center justify-center !rounded-xl border !bg-lightPrimary 
            dark:!bg-navy-900 !text-sm !ring-none focus:!ring-brand-500 
            focus:!border-brand-500 dark:focus:!ring-brand-400 dark:focus:!border-brand-400 
            !outline-none !border-gray-200 dark:!border-white/10 dark:text-white" />
                        <InputRightElement className="!mt-1">
                            <CloseButton onClick={onChangeSearchTermClear} size='md' className={`mr-2 ${searchTerm.trim().length > 0 ? 'scale-100' : 'scale-0'} transition-all duration-500 text-navy-500 dark:text-navy-300`} />
                        </InputRightElement>
                    </InputGroup>
                </div>
                <div className="w-[55px] h-[61px] flex items-center">
                    <TooltipComponent
                        trigger={<button onClick={registrar.onOpen} className="bg-brand-500 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:bg-brand-200 flex items-center justify-center rounded-full p-3 text-3xl text-white transition duration-200 hover:cursor-pointer dark:text-white">
                            <FaPlusCircle />
                        </button>}
                        content={
                            <p className="dark:text-white">
                                registrar producto
                            </p>
                        }
                    />
                </div>
            </div>
            <div className="mt-3 md:mt-8">

                {/** REGISTRAR */}
                <Modal isOpen={registrar.isOpen} onClose={registrar.onClose} headerTitle='Registrar producto'>
                    <div className="px-[5px] md:px-[10px] pt-[20px] pb-[20px] max-w-[1368px] flex flex-col !z-[1004]">
                        <form className="w-full" onSubmit={onSubmitRegistrar}>
                            <div className="flex flex-wrap">
                                <InputField
                                    autoFocus={true}
                                    required={true}
                                    maxLength={35}
                                    variant="input"
                                    extra="w-full md:w-3/12 mb-3 p-2"
                                    label="Nombre"
                                    placeholder="Nombre"
                                    id="name"
                                    type="text"
                                    name="name"
                                    onChange={handleInputs}
                                    value={state.name}
                                />

                                <AutoComplete
                                    extra="w-full md:w-3/12 mb-3 p-2"
                                    label="Almacen"
                                    data={almacenes}
                                    value={state.almacen}
                                    required={true}
                                    labelProp="name"
                                    valueProp="_id"
                                    onChange={(val) => setState({ ...state, almacen: val })}
                                />

                                <AutoComplete
                                    extra="w-full md:w-3/12 mb-3 p-2"
                                    label="Categoría"
                                    data={categorias}
                                    value={state.categoria}
                                    required={true}
                                    labelProp="name"
                                    valueProp="_id"
                                    onChange={(val) => setState({ ...state, categoria: val })}
                                />

                                <AutoComplete
                                    extra="w-full md:w-3/12 mb-3 p-2"
                                    label="Marca"
                                    data={marcas}
                                    value={state.marca}
                                    required={true}
                                    labelProp="name"
                                    valueProp="_id"
                                    onChange={(val) => setState({ ...state, marca: val })}
                                />

                                <AutoComplete
                                    extra="w-full md:w-3/12 mb-3 p-2"
                                    label="U. medida"
                                    data={medidas}
                                    value={state.medida}
                                    required={true}
                                    labelProp="name"
                                    valueProp="_id"
                                    onChange={(val) => setState({ ...state, medida: val })}
                                />

                                <InputField
                                    required={true}
                                    variant="input"
                                    extra="w-full md:w-3/12 mb-3 p-2"
                                    label="Stock"
                                    placeholder="Stock"
                                    id="stock"
                                    min={0}
                                    max={10000}
                                    type="number"
                                    name="stock"
                                    onChange={handleInputs}
                                    value={state.stock}
                                />

                                <InputField
                                    required={true}
                                    readOnly={true}
                                    disabled={true}
                                    variant="input"
                                    extra="w-full md:w-3/12 mb-3 p-2"
                                    extrainput="uppercase"
                                    label="Código interno"
                                    placeholder="Ejemplo PROD_0001"
                                    id="codigointerno"
                                    type="text"
                                    name="codigointerno"
                                    value={state.codigointerno}
                                />

                                <InputField
                                    required={true}
                                    variant="input"
                                    extra="w-full md:w-3/12 mb-3 p-2"
                                    label="Precio compra"
                                    placeholder="Precio compra"
                                    id="preciocompra"
                                    min={0}
                                    max={100000}
                                    type="number"
                                    name="preciocompra"
                                    onChange={handleInputs}
                                    value={state.preciocompra}
                                />

                                <InputField
                                    required={true}
                                    variant="input"
                                    extra="w-full md:w-3/12 mb-3 p-2"
                                    label="Precio venta"
                                    placeholder="Precio venta"
                                    id="precioventa"
                                    min={0}
                                    max={100000}
                                    type="number"
                                    name="precioventa"
                                    onChange={handleInputs}
                                    value={state.precioventa}
                                />

                                <InputField
                                    required={true}
                                    variant="input"
                                    extra="w-full md:w-3/12 mb-3 p-2"
                                    label="Precio por mayor"
                                    placeholder="Precio por mayor"
                                    id="preciomayor"
                                    min={0}
                                    max={100000}
                                    type="number"
                                    name="preciomayor"
                                    onChange={handleInputs}
                                    value={state.preciomayor}
                                />

                                <InputField
                                    required={true}
                                    variant="input"
                                    extra="w-full md:w-3/12 mb-3 p-2"
                                    label="Precio distribuidor"
                                    placeholder="Precio distribuidor"
                                    id="preciodistrubuidor"
                                    min={0}
                                    max={100000}
                                    type="number"
                                    name="preciodistrubuidor"
                                    onChange={handleInputs}
                                    value={state.preciodistrubuidor}
                                />

                                <TextField
                                    required={false}
                                    rows={5}
                                    variant="input"
                                    extra="w-full md:w-3/12 mb-3 p-2"
                                    label="Detalles"
                                    placeholder="Detalles"
                                    id="detalles"
                                    name="detalles"
                                    onChange={handleInputs}
                                    value={state.detalles}
                                />

                                <ImagenPreview url={preview.imagen} prop="imagen" onChange={imageHandle} label="Imagen del producto" />

                                <SwitchToggle
                                    extra="w-full mb-3 p-2"
                                    label="Estado"
                                    id="disabled"
                                    onClick={() => setState({
                                        ...state,
                                        disabled: !state.disabled
                                    })}
                                    value={state.disabled}
                                />
                                <ButtonPrimary isLoading={isLoading} disabled={false} icon={<IoAddCircle size={28} />}>
                                    Registrar
                                </ButtonPrimary>
                            </div>
                        </form>
                    </div>
                </Modal>

                {/** EDITAR */}
                <Modal isOpen={editar.isOpen} onClose={editar.onClose} headerTitle='Editar producto'>
                    <div className="px-[5px] md:px-[10px] pt-[20px] pb-[20px] max-w-[1368px] flex flex-col !z-[1004]">
                        <form className="w-full" onSubmit={onSubmitEditar}>
                            <div className="flex flex-wrap">
                                <InputField
                                    autoFocus={true}
                                    required={true}
                                    maxLength={35}
                                    variant="input"
                                    extra="w-full md:w-3/12 mb-3 p-2"
                                    label="Nombre"
                                    placeholder="Nombre"
                                    id="name"
                                    type="text"
                                    name="name"
                                    onChange={handleEditInputs}
                                    value={stateEdit.name}
                                />

                                <AutoComplete
                                    extra="w-full md:w-3/12 mb-3 p-2"
                                    label="Almacen"
                                    data={almacenes}
                                    value={stateEdit.almacen}
                                    required={true}
                                    labelProp="name"
                                    valueProp="_id"
                                    onChange={(val) => setStateEdit({ ...stateEdit, almacen: val })}
                                />

                                <AutoComplete
                                    extra="w-full md:w-3/12 mb-3 p-2"
                                    label="Categoría"
                                    data={categorias}
                                    value={stateEdit.categoria}
                                    required={true}
                                    labelProp="name"
                                    valueProp="_id"
                                    onChange={(val) => setStateEdit({ ...stateEdit, categoria: val })}
                                />

                                <AutoComplete
                                    extra="w-full md:w-3/12 mb-3 p-2"
                                    label="Marca"
                                    data={marcas}
                                    value={stateEdit.marca}
                                    required={true}
                                    labelProp="name"
                                    valueProp="_id"
                                    onChange={(val) => setStateEdit({ ...stateEdit, marca: val })}
                                />

                                <AutoComplete
                                    extra="w-full md:w-3/12 mb-3 p-2"
                                    label="U. medida"
                                    data={medidas}
                                    value={stateEdit.medida}
                                    required={true}
                                    labelProp="name"
                                    valueProp="_id"
                                    onChange={(val) => setStateEdit({ ...stateEdit, medida: val })}
                                />

                                <InputField
                                    required={true}
                                    variant="input"
                                    extra="w-full md:w-3/12 mb-3 p-2"
                                    label="Stock"
                                    placeholder="Stock"
                                    id="stock"
                                    min={0}
                                    max={10000}
                                    type="number"
                                    name="stock"
                                    onChange={handleEditInputs}
                                    value={stateEdit.stock}
                                />

                                <InputField
                                    required={true}
                                    readOnly={true}
                                    disabled={true}
                                    variant="input"
                                    extra="w-full md:w-3/12 mb-3 p-2"
                                    extrainput="uppercase"
                                    label="Código interno"
                                    placeholder="Ejemplo PRO0001"
                                    id="codigointerno"
                                    type="text"
                                    name="codigointerno"
                                    value={stateEdit.codigointerno}
                                />

                                <InputField
                                    required={true}
                                    variant="input"
                                    extra="w-full md:w-3/12 mb-3 p-2"
                                    label="Precio compra"
                                    placeholder="Precio compra"
                                    id="preciocompra"
                                    min={0}
                                    max={100000}
                                    type="number"
                                    name="preciocompra"
                                    onChange={handleEditInputs}
                                    value={stateEdit.preciocompra}
                                />

                                <InputField
                                    required={true}
                                    variant="input"
                                    extra="w-full md:w-3/12 mb-3 p-2"
                                    label="Precio venta"
                                    placeholder="Precio venta"
                                    id="precioventa"
                                    min={0}
                                    max={100000}
                                    type="number"
                                    name="precioventa"
                                    onChange={handleEditInputs}
                                    value={stateEdit.precioventa}
                                />

                                <InputField
                                    required={true}
                                    variant="input"
                                    extra="w-full md:w-3/12 mb-3 p-2"
                                    label="Precio por mayor"
                                    placeholder="Precio por mayor"
                                    id="preciomayor"
                                    min={0}
                                    max={100000}
                                    type="number"
                                    name="preciomayor"
                                    onChange={handleEditInputs}
                                    value={stateEdit.preciomayor}
                                />

                                <InputField
                                    required={true}
                                    variant="input"
                                    extra="w-full md:w-3/12 mb-3 p-2"
                                    label="Precio distribuidor"
                                    placeholder="Precio distribuidor"
                                    id="preciodistrubuidor"
                                    min={0}
                                    max={100000}
                                    type="number"
                                    name="preciodistrubuidor"
                                    onChange={handleEditInputs}
                                    value={stateEdit.preciodistrubuidor}
                                />

                                <TextField
                                    required={false}
                                    variant="input"
                                    extra="w-full md:w-3/12 mb-3 p-2"
                                    label="Detalles"
                                    placeholder="Detalles"
                                    id="detalles"
                                    name="detalles"
                                    onChange={handleEditInputs}
                                    value={stateEdit.detalles}
                                />

                                <ImagenPreviewEdit url={previewEdit.imagen} currentImagen={stateEdit.currentimagen} prop="imagen" onChange={imageHandleEdit} label="Imagen del producto" />

                                <SwitchToggle
                                    extra="w-full mb-3 p-2"
                                    label="Estado"
                                    id="disabled"
                                    onClick={() => setStateEdit({
                                        ...stateEdit,
                                        disabled: !stateEdit.disabled
                                    })}
                                    value={stateEdit.disabled}
                                />

                                <InputField
                                    required={false}
                                    disabled={true}
                                    variant="input"
                                    extra="w-full md:w-3/12 mb-3 p-2"
                                    label="Última vez que se actualizó"
                                    placeholder="Última vez que se actualizó"
                                    id="last_update"
                                    type="text"
                                    name="last_update"
                                    value={moment(stateEdit.last_update).format('dddd, D [de] MMMM [de] YYYY, h:mm a')}
                                />

                                <ButtonPrimary isLoading={isLoading} disabled={false} icon={<FaEdit size={28} />}>
                                    Editar
                                </ButtonPrimary>
                            </div>
                        </form>
                    </div>
                </Modal>

                <div className="mt-5 grid h-full grid-cols-1">
                    <TablePagination
                        searchTerm={searchTerm}
                        tableData={dataByPage}
                        fetchData={fetchData}
                        loading={isLoading}
                        pageCount={totalPage}
                        totalRow={totalRow}
                        actions={{
                            onEdit: (item) => handleEdit(item),
                            onDelete: (item) => handleDelete(item)
                        }}
                    />
                </div>
            </div>
        </div >

    );
};

export default Productos;
